<template>
    <div class="personal-form">
        <div class="personal-form__title">
            Renseignements
        </div>
        <div class="personal-form__form">
            <div class="col">
                <div class="form-group">
                    <label v-tap for="first_name">Prénom</label>
                    <input v-on:keyup="formUpdated" id="first_name" v-model="form.first_name" type="text" placeholder="Prénom">
                </div>
                <div class="form-group">
                    <label for="#">Type d'entrée</label>
                    <div class="checkboxes">
                        <div class="checkboxes__item" v-tap v-on:click="setEntryType('pass')"  :class="{ 'selected' : form.entry_type === 'pass'}">Pass annuel</div>
                        <div class="checkboxes__item" v-tap v-on:click="setEntryType('individual')"  :class="{ 'selected' : form.entry_type === 'individual'}">Individuelle</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="zip_code">Code postal</label>
                    <input v-on:keyup="formUpdated" type="number" id="zip_code" v-model="form.zip_code" placeholder="Code postal">
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label for="last_name">Nom de famille</label>
                    <input v-on:keyup="formUpdated" type="text" id="last_name" v-model="form.last_name" placeholder="Nom de famille">
                </div>
                <div class="form-group">
                    <label for="email">Adresse email</label>
                    <input v-on:keyup="formUpdated" type="email" id="email" v-model="form.email" placeholder="Adresse email">
                </div>
                <div class="form-group">
                    <label for="#">Tranche d'age</label>
                    <div class="checkboxes checkboxes--age">
                        <div class="checkboxes__item" v-tap v-on:click="setAgeRange('18-35')"  :class="{ 'selected' : form.age_range === '18-35'}">18-35</div>
                        <div class="checkboxes__item" v-tap v-on:click="setAgeRange('35-45')"  :class="{ 'selected' : form.age_range === '35-45'}">35-45</div>
                        <div class="checkboxes__item" v-tap v-on:click="setAgeRange('45-60')"  :class="{ 'selected' : form.age_range === '45-60'}">45-60</div>
                        <div class="checkboxes__item" v-tap v-on:click="setAgeRange('60-75')"  :class="{ 'selected' : form.age_range === '60-75'}">60-75</div>
                        <div class="checkboxes__item" v-tap v-on:click="setAgeRange('+75')"  :class="{ 'selected' : form.age_range === '+75'}">+ 75</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="notice">
            Laissez les champs vides si l'utilisateur n'as pas souhaité répondre
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Survey',
        props: ['survey'],
        data() {
            return {
                form: {
                    first_name: null,
                    last_name: null,
                    zip_code: null,
                    email: null,
                    age_range: null,
                    entry_type: null
                }
            };
        },
        methods: {
            setEntryType(value) {
                this.form.entry_type = value;
                this.formUpdated();
            },
            setAgeRange(value) {
                this.form.age_range = value;
                this.formUpdated();
            },
            formUpdated() {
                this.$emit('valueChanged', this.form);
            }
        },
        created() {

        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    .notice{
        font-style: italic;
        margin-top: 40px;

        @media only screen
        and (orientation : portrait) {
            margin-top: 20px;
        }
    }

    .checkboxes{
        display: flex;

        &__item{
            margin-right: 20px;
            display: block;
            background-color: white;
            text-align: center;
            border: 0;
            box-shadow: 0 2px 4px 0 rgba(178, 178, 178, 0.50);
            width: 100%;
            padding: 18px 25px;
            font-size: 17px;
            border-radius: 6px;
            outline: none;
            position: relative;


            &:last-child{
                margin-right: 0;
            }

            &.selected{
                font-weight: 600;

                &:after{
                    position: absolute;
                    content: "";
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    box-shadow: inset 0px 0px 0px 5px rgba(160,212,125,1);
                    border-radius: 6px;
                }
            }
        }

        &--age{
            .checkboxes__item{
                margin-right: 10px;
                padding: 22px 5px;
                font-size: 12px;
                font-weight: 600;
            }
        }
    }

    .personal-form{
        margin-top: 40px;

        &__title{
            text-transform: uppercase;
            font-weight: 500;
            letter-spacing: 1px;
            font-size: 20px;
            margin-bottom: 40px;
        }


        &__form{
            display: flex;
            justify-content: space-between;
            max-width: 85%;
            margin: auto;

            .col{
                width: 50%;
                margin: 0 20px;
            }

            @media only screen
            and (orientation : portrait) {
                flex-direction: column;
                align-items: center;
                .col{
                    width: 100%;
                }
            }
        }

    }

    .form-group {
        display: block;
        text-align: left;
        margin-bottom: 25px;

        label {
            display: block;
            font-weight: 600;
            font-size: 16px;
            margin-bottom: 10px;
        }

        input {
            appearance: none;
            border: 0;
            box-shadow: 0 2px 4px 0 rgba(178, 178, 178, 0.50);
            display: block;
            width: 100%;
            padding: 18px 25px;
            font-size: 17px;
            border-radius: 6px;
            outline: none;
        }
    }
</style>
